import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import {
  FieldTypes,
  FieldWithValueProps,
} from '@sitecore-jss/sitecore-jss-react-forms';
import { BiInfoCircle } from 'react-icons/bi';
import { IReduxState } from '../../../ReduxImpl/reducers/index';
import { useTranslation } from 'react-i18next';

const FieldWrapper: FC<FieldWithValueProps> = (props) => {
  const { t } = useTranslation();
  const Circle: any = BiInfoCircle;
  const hasRadioBtn =
    props.field.model.fieldTypeItemId === FieldTypes.RadioButtonList;

  const hideButton = useSelector((state: IReduxState) => state.hideButton);
  const name = props.field.model.name;
  const captcha = useSelector((state: IReduxState) => state.captcha);
  const disableButton = useSelector((state: IReduxState) => state.disableButton); 

  const cssClass = (props.field.model as { [key: string]: any })?.cssClass ?? '';

  return (
    <div
      className={`sitecore-jss-form__field-wrapper ${cssClass} ${
        hasRadioBtn ? 'sitecore-jss-form__field-wrapper--radio-btn' : ''
      } ${
        name === 'IDDocument'
          ? 'sitecore-jss-form__field-wrapper--fileupload'
          : ''
      }
      ${
        name === 'ChangeLanguageText'
          ? 'sitecore-jss-form__field-wrapper--ChangeLanguageText'
          : ''
      } 
      ${
        name === 'FormInfoText'
          ? 'sitecore-jss-form__field-wrapper--FormInfoText'
          : ''
      }
      ${
        name === 'PrivacyPolicyText'
          ? 'sitecore-jss-form__field-wrapper--PrivacyPolicyText'
          : ''
      }
      ${
        name === 'DataCategoriesText'
          ? 'sitecore-jss-form__field-wrapper--DataCategoriesText'
          : ''
      }
      ${
        name === 'SubscribeButton' && hideButton
          ? 'sitecore-jss-form__field-wrapper--DisableSubscribeButton'
          : 'sitecore-jss-form__field-wrapper--EnableSubscribeButton'
      }
      ${
        name === 'SubscribeButton' && captcha
          ? 'sitecore-jss-form__field-wrapper--DisableSubscribeButton'
          : ''
      }
      ${
        name === 'SubmitButton' && captcha
          ? 'sitecore-jss-form__field-wrapper--DisableSubmitButton'
          : ''
      }
      ${
        (name === 'Submit Button' || name === 'SubscribeButton') && disableButton
          ? 'sitecore-jss-form__field-wrapper--DisableSubscribeButton'
          : ''
      }
      ${
        name === 'SubmitButton' && !captcha
          ? 'sitecore-jss-form__field-wrapper--SubmitButton'
          : ''
      }
      ${
        name === 'SubscriberText'
          ? 'sitecore-jss-form__field-wrapper--subscribeText'
          : ''
      }
      ${
        name === 'MarketingActivitiesDetails'
          ? 'MarketingActivitiesDetailsLabel'
          : ''
      }
			${name === 'Text' ? 'sitecore-jss-form__field-wrapper--Text' : ''}
     `}
    >
      {props.children}

      {name === 'IDDocument' ? (
        <div>
          <div className="sitecore-jss-form__field-wrapper--file">
            <div>
              <Circle className="sitecore-jss-form__field-wrapper--file-icon" />
            </div>

            <div className="sitecore-jss-form__field-wrapper--file-label">
              <label>
                {t("FileSize")}<br />
                {t("FileFormats")}
              </label>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default FieldWrapper;
